.mainScreen {
  color: #231E19;
}

.title {
  text-align: center;
  font-family: ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif;
  font-size: 34px;
  font-weight: 800;
  line-height: 41px;
  letter-spacing: -0.4px;
  margin-top: 14px;
  margin-bottom: 8px;
  padding: 0 20px;

  @at-root html[lang="de"] & {
    font-size: 28px;
  }

  @media (max-width: 375px) {
    @at-root html[lang="de"] & {
      font-size: 26px;
    }
  }
}

.subtitle {
  text-align: center;
  font-size: 17px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.051px;
  padding: 0 20px;
  margin-bottom: 20px;

  span {
    font-weight: 700;
  }
}

.imgWrapper {
  width: 100%;
  position: relative;
}

.label {
  position: absolute;
  top: 0;
  right: 0;
  transform: translateY(-33%);
  width: 100px;
  height: 100px;
}

.image {
  border-radius: 32px;
  padding: 0 20px;
}